export default __webpack_public_path__ + "media/images/logo-7cc3c28c.svg";